/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Cardano API
 * RESTful API for Cardano
 * OpenAPI spec version: 1.0.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AddressUtxosResponse
} from '../model';

import { arbBotFetcher } from '../../../lib/api/fetcher.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGetAddressUtxosByAddressUrl = (address: string,) => {




  return `/api/addresses/${address}`
}

export const getAddressUtxosByAddress = async (address: string, options?: Parameters<typeof arbBotFetcher>[1]): Promise<AddressUtxosResponse> => {

  return arbBotFetcher<AddressUtxosResponse>(getGetAddressUtxosByAddressUrl(address),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAddressUtxosByAddressQueryKey = (address: string,) => {
    return [
    `/api/addresses/${address}`
    ] as const;
    }


export const getGetAddressUtxosByAddressQueryOptions = <TData = Awaited<ReturnType<typeof getAddressUtxosByAddress>>, TError = unknown>(address: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAddressUtxosByAddress>>, TError, TData>>, request?: SecondParameter<typeof arbBotFetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAddressUtxosByAddressQueryKey(address);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAddressUtxosByAddress>>> = ({ signal }) => getAddressUtxosByAddress(address, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: address !== null && address !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAddressUtxosByAddress>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAddressUtxosByAddressQueryResult = NonNullable<Awaited<ReturnType<typeof getAddressUtxosByAddress>>>
export type GetAddressUtxosByAddressQueryError = unknown


export function useGetAddressUtxosByAddress<TData = Awaited<ReturnType<typeof getAddressUtxosByAddress>>, TError = unknown>(
 address: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAddressUtxosByAddress>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAddressUtxosByAddress>>,
          TError,
          Awaited<ReturnType<typeof getAddressUtxosByAddress>>
        > , 'initialData'
      >, request?: SecondParameter<typeof arbBotFetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAddressUtxosByAddress<TData = Awaited<ReturnType<typeof getAddressUtxosByAddress>>, TError = unknown>(
 address: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAddressUtxosByAddress>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAddressUtxosByAddress>>,
          TError,
          Awaited<ReturnType<typeof getAddressUtxosByAddress>>
        > , 'initialData'
      >, request?: SecondParameter<typeof arbBotFetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAddressUtxosByAddress<TData = Awaited<ReturnType<typeof getAddressUtxosByAddress>>, TError = unknown>(
 address: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAddressUtxosByAddress>>, TError, TData>>, request?: SecondParameter<typeof arbBotFetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAddressUtxosByAddress<TData = Awaited<ReturnType<typeof getAddressUtxosByAddress>>, TError = unknown>(
 address: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAddressUtxosByAddress>>, TError, TData>>, request?: SecondParameter<typeof arbBotFetcher>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAddressUtxosByAddressQueryOptions(address,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






